export default {
  weight : ['0,25', '0,5', '1', '1,5', '2', '2,5', '3', '4', '5', '6', '7', '8', '9', '10', '12', '13', '14', '15', '16', '17', '18', '19', '20', '22', '24', '26', '28', '30', '35', '40', '42', '44', '46', '48', '50'],
  friction : ['0,6', '0,3', '0,2'],
  results: [
    ['250', '250', '250'],
    ['250', '250', '500'],
    ['250', '500', '1000'],
    ['250', '750', '1500'],
    ['500', '1000', '2000'],
    ['500', '1500', '2500'],
    ['500', '1500', '4000'],
    ['750', '2000', '4000'],
    ['750', '2500', '5300'],
    ['1000', '4000', '6300'],
    ['1000', '4000', '6300'],
    ['1500', '4000', '10000'],
    ['1500', '6300', '10000'],
    ['1500', '6300', '10000'],
    ['2000', '6300', '16000'],
    ['2000', '10000', '16000'],
    ['2000', '10000', '16000'],
    ['2000', '10000', '16000'],
    ['2500', '10000', '16000'],
    ['2500', '10000', '16000'],
    ['2500', '10000', '20000'],
    ['4000', '10000', '20000'],
    ['4000', '10000', '20000'],
    ['4000', '16000', '20000'],
    ['4000', '16000', 'nelze'],
    ['4000', '16000', 'nelze'],
    ['4000', '16000', 'nelze'],
    ['4000', '16000', 'nelze'],
    ['6300', '20000', 'nelze'],
    ['6300', '20000', 'nelze'],
    ['6300', 'nelze', 'nelze'],
    ['6300', 'nelze', 'nelze'],
    ['6300', 'nelze', 'nelze'],
    ['10000', 'nelze', 'nelze'],
    ['10000', 'nelze', 'nelze']
  ]
}